import {Component, Input, OnInit} from '@angular/core';
import {BreadcrumbsService} from '../../services/breadcrumbs.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
    @Input() absolute = false;
    destroy$ = new Subject<void>();
    routes = [];

    constructor(
        private breadcrumbsService: BreadcrumbsService
    ) {
    }

    ngOnInit(): void {
        this.breadcrumbsService.breadcrumbChanged.pipe(takeUntil(this.destroy$)).subscribe(
            (value) => {
                this.routes = value;
            });

        this.breadcrumbsService.isFloatingChanged.pipe(takeUntil(this.destroy$)).subscribe(
            (value) => {
                this.absolute = value;
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
